module.exports = __webpack_public_path__ + "img/DE05696.45c8312a.png";